var linkElementToAppendCSS = document.createElement('link');
linkElementToAppendCSS.href = '//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/parcelamento.css?v=92345602073641733491614793351';
linkElementToAppendCSS.type = 'text/css';
linkElementToAppendCSS.rel = 'stylesheet';
linkElementToAppendCSS.media = 'screen,print';
document.getElementsByTagName('head')[0].appendChild(linkElementToAppendCSS);

document.addEventListener('DOMContentLoaded', function(){
  if (window.location.href.indexOf('cart') != -1) {
    document.getElementById('frete').style.display='none';
  }
});



var writeInstallments = function(){
  
  
 
  var shop_installments = 6;  
  var installmentsText = "<span class='installments-plugin-snippet' style='display: none;font-weight:bold;font-family: sans-serif;text-transform: uppercase;font-size:60%;color:#000'><br /> <i class='fas fa-credit-card'></i>  Em até 12x no Cartão <p></p><i class='fas fa-barcode'></i>  Boleto Somente à Vista<p></p><i class='fas fa-truck'></i>  <strong>Frete Grátis</strong> para Todo Brasil</span> </font></span><div class='checkout-btns'><div id='row_btns_a' class='row_btn'><img data-img='visa' src='//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/visa.svg?v=168040035931801853681614793361'><img data-img='master' src='//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/master.svg?v=15667395479656974811614793348'><img data-img='amex' src='//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/amex.svg?v=146829377703623274661614793331'><img data-img='hipercard' src='//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/hipercard.svg?v=93310188086851652481614793342'><img data-img='dinners' src='//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/dinners.svg?v=53706485292855968181614793336'><img data-img='elo' src='//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/elo.svg?v=42898520462044191101614793337'><p id='parcelas_click'><img src='//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/down-arrow.svg?v=17954724648468410971614793337' /></p></div><div id='row_btns_c' style='display:none;'><ul class='col-lg-6'><li id='1x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=#101113>1x</FONT></li><li id='2x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>2x</FONT></li><li id='3x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>3x</FONT></li> <li id='4x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>4x</FONT></li> <li id='5x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>5x</FONT></li><li id='6x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>6x</FONT></li> </ul><ul class='col-lg-6'><li id='7x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>7x</FONT></li><li id='8x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>8x</FONT></li><li id='9x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>9x</FONT></li><li id='10x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>10x</FONT></li><li id='11x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>11x</FONT></li><li id='12x'><FONT  SIZE=2 FONT-WEIGHT: BOLD COLOR=black>12x</FONT></li></ul></div><div id='row_btns_b' class='row_btn'><p class='boleto-icon'><img data-img='boleto' src='//cdn.shopify.com/s/files/1/0550/4224/4757/t/2/assets/boleto.svg?v=29042640155392895611614793331'><span class='parcelas'>R$ &price&</span></div></div></div>";
  var installmentsText2 = "<p class='frete-btn' style='margin-top:5px; text-align:center'><span id='frete'>&nbsp;&nbsp; Frete Grátis &nbsp;&nbsp;</span></p>";
  //var installmentsText3 = "<p style='margin-top:5px'><font style='font-size:96%;font-weight:normal'>ou R$ &price+17/100& à vista no Boleto Bancário</font></p>";
  var installmentsText3 = "<span class='installments-plugin-snippet' style='display: none;text-transform:uppercase;font-family: sans-serif;font-weight:bold;font-size:99%;color:#000'><br />ou  6x de &dividedPrice& <font style='font-weight:normal'> sem juros </font></span>";

  var installmentsTextMobile = "<span class='installments-plugin-snippet' style='display: none;padding-top:3px;font-size:87%;font-weight:bold'><br />6x de &dividedPrice& <font style='font-weight:bold'> sem juros </font></span>";
  var regexpToGetProductPrice = /\d*\.?\d+,?\d*/;

 
  // Gotta rename this function now that we are accepting more currencies
  function convertFloatToBrazilianPriceFormat(productPrice) {
    var productPriceInBRL;
    var currencySymbol;
    var mapObj = {
       ".":","
    };

    productPriceInBRL = productPrice.replace(/,|\./gi, function(matched){
      return mapObj[matched];
    });

    currencySymbol = (window.ShopifyAnalytics.meta.currency === 'BRL' ? 'R$ ' : '$ ')

    return currencySymbol + productPriceInBRL;
  }

  function convertPriceToUsFormat(productPrice) {
    var mapObj = {
       ".":"",
       ",":"."
    };

    productPrice = productPrice.replace(/,|\./gi, function(matched){
      return mapObj[matched];
    });

    return parseFloat(productPrice)
  }

  function isGreaterThanZero(regexpMatch) {
    return regexpMatch !== null && regexpMatch[0] !== '0,00' && regexpMatch[0] !== '0.00' && regexpMatch[0] !== '0'
  }

  function currencyUsesCommaAsCentsDivision() {
    return (window.ShopifyAnalytics.meta.currency === 'BRL') || (window.ShopifyAnalytics.meta.currency === 'ARS')
  }

  
  
  function installmentsHtml(productPrice) {
    var productPriceAsFloat = (currencyUsesCommaAsCentsDivision() ? convertPriceToUsFormat(productPrice) : productPrice)
    var dividedPrice = (productPriceAsFloat / shop_installments).toFixed(2);

    return [installmentsText.replace('&price&', productPrice).replace('&dividedPrice&', convertFloatToBrazilianPriceFormat(dividedPrice)), installmentsText2.replace('&dividedPrice&', convertFloatToBrazilianPriceFormat(dividedPrice))];
    
  }
  
  function installmentsHtmlCart(productPrice) {
    var productPriceAsFloat = (currencyUsesCommaAsCentsDivision() ? convertPriceToUsFormat(productPrice) : productPrice)
    var dividedPrice = (productPriceAsFloat / shop_installments).toFixed(2);
    return [installmentsText3.replace('&dividedPrice&', convertFloatToBrazilianPriceFormat(dividedPrice))];
    
  }
  
  
  
  
  function installmentsHtmlMobile(productPrice) {
    var productPriceAsFloat = (currencyUsesCommaAsCentsDivision() ? convertPriceToUsFormat(productPrice) : productPrice)
    var dividedPrice = (productPriceAsFloat / shop_installments).toFixed(2);

    return installmentsTextMobile.replace('&dividedPrice&', convertFloatToBrazilianPriceFormat(dividedPrice));
  }

  function textOutsideTags($element) {
    return $element.clone()
      .children()
      .remove()
      .end()
      .text();
  }

  
// Home || Catalog || Recommended Products || Search
if ($('.grid-view-item span.product-price__price').length) {
  $('.grid-view-item span.product-price__price').each(function() {
    var regexpMatch = textOutsideTags($(this)).match(regexpToGetProductPrice);

    if (isGreaterThanZero(regexpMatch)) {
      var productPrice = regexpMatch[0];
      $(this).parent().append(installmentsHtmlMobile(productPrice));
    }
  });
}


// Product page || Featured page
function addInstallmentsPriceToProductPage($productPrice) {
  $productPrice = $('.product-single__meta .product-price__price > span:not(.save_discount_pro, .per_discount, #ComparePrice-product-template, .sale-tag)');

  $productPrice.each(function() {
    
    $this = $(this);
    var regexpMatch = $this.text().match(regexpToGetProductPrice)[0]; 
    if (isGreaterThanZero(regexpMatch)) {
      $this.parent().parent().append(installmentsHtml(regexpMatch));
    }
    
    $("#row_btns_a").click(function(){
      $("#row_btns_c").toggle("slow");
    });
    
    var total = parseFloat(regexpMatch.replace("R$", "").replace(",","."));    
    
 $("#1x").append("<span> de <price> R$"+(total/1).toFixed(2).toString().replace(".",",")+"</price></span>");
    $("#2x").append("<span> de <price> R$"+(total/2).toFixed(2).toString().replace(".",",")+"</price> sem juros</span>");
    $("#3x").append("<span> de <price> R$"+(total/3).toFixed(2).toString().replace(".",",")+"</price> sem juros</span>");
    $("#4x").append("<span> de <price> R$"+(total/4).toFixed(2).toString().replace(".",",")+"</price> sem juros</span>");
    $("#5x").append("<span> de <price> R$"+(total/5).toFixed(2).toString().replace(".",",")+"</price> sem juros</span>");
    $("#6x").append("<span> de <price> R$"+(total/6).toFixed(2).toString().replace(".",",")+"</price> sem juros</span>");
    $("#7x").append("<span> de <price> R$"+((total + (total * (10.06/100)))/7).toFixed(2).toString().replace(".",",")+"</price></span>");
    $("#8x").append("<span> de <price> R$"+((total + (total * (10.62/100)))/8).toFixed(2).toString().replace(".",",")+"</price></span>");
    $("#9x").append("<span> de <price> R$"+((total + (total * (11.23/100)))/9).toFixed(2).toString().replace(".",",")+"</price></span>");
    $("#10x").append("<span> de <price> R$"+((total + (total * (12.41/100)))/10).toFixed(2).toString().replace(".",",")+"</price></span>");
    $("#11x").append("<span> de <price> R$"+((total + (total * (13.60/100)))/11).toFixed(2).toString().replace(".",",")+"</price></span>");
    $("#12x").append("<span> de <price> R$"+((total + (total * (14.80/100)))/12).toFixed(2).toString().replace(".",",")+"</price></span>");
    
  });
}

  
  
if ($('.product-single__meta').length) {
  
  
  
  addInstallmentsPriceToProductPage();
  
 
  $('.product-single__meta .product-price__price').on('DOMSubtreeModified', '> span:not(.save_discount_pro, .per_discount)', function(){
    setTimeout(
    function()
    {
      $('.product-single__meta .installments-plugin-snippet').remove();
      addInstallmentsPriceToProductPage();
    }, 100);
  });
  
  
}

// Cart page
if ($('body.template-cart').length) {
  var $productPrice = $('.cart__subtotal .crt_total .wh-cart-total');
  var regexpMatch = $productPrice.text().match(regexpToGetProductPrice);

  if (isGreaterThanZero(regexpMatch)) {
    var price = regexpMatch[0];
    $productPrice.parent().parent().append(installmentsHtmlCart(price));
  } else {
  	var $productPrice = $('.cart__subtotal .crt_total');
  	var regexpMatch = $productPrice.text().match(regexpToGetProductPrice);
    var price = regexpMatch[0];
    $productPrice.parent().parent().append(installmentsHtmlCart(price));
  }
  
}
  
  
  
};




if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {    
  writeInstallments();      
} else {    
  document.addEventListener("onreadystatechange", writeInstallments);      
}

